import { common } from '@kurtosys/ksys-app-template';
import { IQueryOrValue } from '@kurtosys/types/query/IQueryOrValue.js';
import { computed, makeObservable } from 'mobx';

import { IAssets } from '../models/IAssets.js';
import { IComponentConfiguration } from '../models/IComponentConfiguration.js';

/**
 * Dummy store
 * For use with Storybook stories to test Accessibility
 */

interface ITableAccessibilityConfig {
	caption?: IQueryOrValue;
	summary?: IQueryOrValue;
}

interface IChartingAccessibilityConfig {
	caption?: string;
	summary?: string;
}

interface IAccessibilityValues {
	asset?: IAssets;
	tables?: {
		[key: string]: IAccessibilityValue<ITableAccessibilityConfig>;
	};
	charting?: IChartingAccessibilityConfig;
}

type IAccessibilityValue<T> = {
	[key in keyof T]: string;
};

export class AccessibilityStore {
	constructor() {
		makeObservable(this, {
			appConfiguration: computed,
			accessibilityValues: computed,
		});
	}

	get appConfiguration() {
		return {} as IComponentConfiguration;
	}

	get accessibilityValues(): IAccessibilityValues {
		const config: IAccessibilityValues = {
			asset: {
				base: {
					checkbox: {
						checked: 'Checkbox that is checked',
					},
					tooltip: {
						defaultIcon: 'A Tooltip icon',
					},
				},
			},
			charting: {
				summary: 'Bar Chart starting with ten thousand US dollars.',
			},
		};
		return config;
	}

	accessibilityText = (key: string, defaultValue: string) => {
		if (typeof key === 'string' && !key.startsWith('asset') && !key.startsWith('charting')) {
			key = 'asset.' + key;
		}
		return common.commonUtils.getValueFromDotNotation(key, this.accessibilityValues, defaultValue);
	};
}
